// extracted by mini-css-extract-plugin
module.exports = {"cell":"WGpnEZ"};